<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="contact-form col-lg-6">
              <form id="contact" action="#" method="post" @submit="checkForm">
                <div v-if="errors.length" class="alert alert-warning">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                  </ul>
                </div>

                <div v-if="serverMessage" class="alert alert-success">
                  {{ serverMessage }}
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">ফোন<span class="required">*</span></label>
                  <input id="exampleInputEmail1" v-model="phone" type="number" class="form-control" name="phone" aria-describedby="emailHelp" placeholder="আপনার মোবাইল নাম্বার এখানে লিখুন" required>
                </div>

                <button type="submit" class="btn btn-primary">
                  পরবর্তী ধাপে যান <i class="fa fa-chevron-right"></i>
                </button>

                <div class="mt-2">
                  <router-link :to="{ name: 'login' }">লগইন করুন</router-link>
                </div>
                <div>
                  <router-link :to="{ name: 'signup' }">অ্যাকাউন্ট নেই? এখনই সাইন আপ করুন!</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `login`,
  components: {
    Layout,
  },
  data() {
    return {
      errors: [],
      serverMessage: false,
      phone: null,
    };
  },
  methods: {
    async checkForm(e) {
      if (this.phone) {
        e.preventDefault();
        const formData = new FormData();
        formData.append(`phone`, this.phone);
        const response = await fetch(`${this.APIURL}customer/forgot-password/send-otp`, {
          method: `POST`,
          body: formData,
        });
        const sendOtpResponse = await response.json();
        if (!sendOtpResponse.status) this.serverMessage = sendOtpResponse.message;

        localStorage.setItem('forgotMobile', this.phone);
        this.$router.push('forgot-password-otp')
        this.flashMessage.success({ message: sendOtpResponse.message });
      }

      this.errors = [];

      if (!this.phone) {
        this.errors.push(`Phone required.`);
      }

      e.preventDefault();
    },
  },
};
</script>
